import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { clearOffline } from "./offline";
import { useLang } from "./i18n";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const { setLang } = useLang();

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("hf_token")) { setUser(null); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("hf_user", JSON.stringify(data));
      if (data.lang) setLang(data.lang);
    } catch (e) {
      const cached = localStorage.getItem("hf_user");
      setUser(!e?.response && cached ? JSON.parse(cached) : null);
    }
    setReady(true);
  }, [setLang]);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("hf_token", data.token);
    const local = localStorage.getItem("hf_lang");
    if (local && local !== data.user.lang) { api.post("/auth/lang", { lang: local }).catch(() => {}); data.user.lang = local; }
    setUser(data.user);
    localStorage.setItem("hf_user", JSON.stringify(data.user));
    return data.user;
  };
  const logout = () => { localStorage.removeItem("hf_token"); localStorage.removeItem("hf_user"); clearOffline(); setUser(null); };

  return <AuthCtx.Provider value={{ user, ready, login, logout, refresh, setUser }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
export const isStaff = (u) => u && ["admin", "exporter"].includes(u.role);
export const homePath = (u) => (u?.role === "supervisor" ? "/home" : u?.role === "packing_house" ? "/incoming" : "/dashboard");
